import { z } from 'zod';

import { IndexRateType } from '../../../indexRate/IndexRate';
import { ArmRoundingType } from '../../../loan/Loan';
import { DateString, NonNegativeFloat, NonNegativeInteger, NonNegativePercentage, PositiveInteger } from '../../fields';

export const ArmFields = z.object({
  armIndex: IndexRateType.optional(),
  armFixedTermMonths: NonNegativeInteger.optional(),
  armFirstRateChangeDate: DateString.optional(),
  armMarginPercent: NonNegativePercentage.optional(),
  armMarginDecimal: NonNegativeFloat.optional(),
  armMaxIncreasePerPeriodPercent: NonNegativePercentage.optional(),
  armMaxIncreasePerPeriodDecimal: NonNegativeFloat.optional(),
  armMinIncreasePerPeriodPercent: NonNegativePercentage.optional(),
  armMinIncreasePerPeriodDecimal: NonNegativeFloat.optional(),
  armMaxIncreaseForFirstPeriodPercent: NonNegativePercentage.optional(),
  armMaxIncreaseForFirstPeriodDecimal: NonNegativeFloat.optional(),
  armMinIncreaseForFirstPeriodPercent: NonNegativePercentage.optional(),
  armMinIncreaseForFirstPeriodDecimal: NonNegativeFloat.optional(),
  armRateCeilingPercent: NonNegativePercentage.optional(),
  armRateCeilingDecimal: NonNegativeFloat.optional(),
  armRateFloorPercent: NonNegativePercentage.optional(),
  armRateFloorDecimal: NonNegativeFloat.optional(),
  armRateAdjustmentFrequency: PositiveInteger.optional().meta({
    description: 'The number of months between rate adjustments',
    example: 6,
  }),
  armAdjustmentLeadCountDays: NonNegativeInteger.optional(),
  armRoundingType: ArmRoundingType.optional(),
  armRoundingPercent: NonNegativePercentage.optional(),
  armRoundingDecimal: NonNegativeFloat.optional(),
});

export type ArmFields = z.infer<typeof ArmFields>;
